import React from 'react';
import './categorybutton.css'

const Categorybutton = (props) => {
  return ( 
    <button className={props.categorystyle}>
      <img src={props.categoryimg} alt="" />{props.categorytext}
    </button>
   );
}
 
export default Categorybutton;
